enum MagicLoginCodes {
  MagicUnexpected = "PB_MAGIC_UNEXPECTED",
  MagicBadRequest = "PB_MAGIC_BAD_REQUEST",
  MagicResendNotAllowed = "PB_MAGIC_RESEND_NOT_ALLOWED",
  MagicExpired = "PB_MAGIC_EXPIRED",
  MagicAlreadyUsed = "PB_MAGIC_ALREADY_USED",
  MagicUndeliverableEmail = "PB_MAGIC_UNDELIVERABLE_EMAIL",
  MagicInvalidPhoneNumber = "PB_MAGIC_INVALID_PHONE_NUMBER",
  MagicAttemptsExceeded = "PB_MAGIC_ATTEMPTS_EXCEEDED"
}

export default MagicLoginCodes
